import React from 'react';

/**
 * AlertModal Component
 * Uses dedicated .btn-alert-* classes for different alert types (success, error, warning, info, confirm)
 * This maintains CSS consolidation without inline style overrides
 */
const AlertModal = ({ isOpen, onClose, title, message, type = 'info', confirmText = 'OK', onConfirm }) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const getIcon = () => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'confirm': return '❓';
      default: return 'ℹ️';
    }
  };

  const getButtonClass = () => {
    switch (type) {
      case 'success': return 'btn-alert-success';
      case 'error': return 'btn-alert-error';
      case 'warning': return 'btn-alert-warning';
      case 'confirm': return 'btn-alert-confirm';
      default: return 'btn-alert-info';
    }
  };

  const icon = getIcon();
  const buttonClass = getButtonClass();

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '400px' }}>
        <div className="modal-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <span style={{ fontSize: '32px' }}>{icon}</span>
            <h3>{title || (type === 'confirm' ? 'Confirm' : type.charAt(0).toUpperCase() + type.slice(1))}</h3>
          </div>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <div style={{ padding: '20px 0' }}>
          <p style={{ color: '#334155', fontSize: '16px', lineHeight: '1.6', margin: 0 }}>
            {message}
          </p>
        </div>

        <div className="modal-footer">
          {type === 'confirm' ? (
            <>
              <button onClick={onClose} className="btn-secondary">
                Cancel
              </button>
              <button onClick={handleConfirm} className={buttonClass}>
                {confirmText}
              </button>
            </>
          ) : (
            <button onClick={handleConfirm} className={buttonClass}>
              {confirmText}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default AlertModal;
